module.exports = __webpack_public_path__ + "img/pla_HM.7756b365.png";